import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { IntroVideoType } from '~/models/intro-video/model';
import { isUrlValid } from '~/utils/videoUrl/videoUrl';
export const MAX_CUSTOM_PAGES = 10;
export const DEFAULT_PAGE_TITLE = 'Custom page';
export const DEFAULT_DISPLAY_SCOPE = 'proposalOnly';
export const PDF_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
export const isProposalAndAgreement = (page)=>page.displayScope === 'proposalAndAgreement';
export const supportsDisplayScope = (page)=>page.type !== 'video';
export const sortedPages = (pages)=>[
        ...pages
    ].sort((a, b)=>a.displayOrder - b.displayOrder);
export const agreementPages = (pages)=>sortedPages(pages.filter((page)=>isProposalAndAgreement(page) && page.type !== 'video'));
export const reindexDisplayOrders = (pages)=>pages.map((page, index)=>_object_spread_props(_object_spread({}, page), {
            displayOrder: index
        }));
export const reorderVisibleKeepingHidden = (allPages, reorderedVisibleIds, hiddenPageIds)=>{
    const visibleById = new Map(allPages.filter((p)=>!hiddenPageIds.has(p.id)).map((p)=>[
            p.id,
            p
        ]));
    const reorderedVisible = reorderedVisibleIds.map((id)=>visibleById.get(id)).filter((p)=>p != null);
    const hidden = sortedPages(allPages.filter((p)=>hiddenPageIds.has(p.id)));
    return reindexDisplayOrders([
        ...reorderedVisible,
        ...hidden
    ]);
};
export const customPagesEnabled = (ffEnabled, pages, introVideo)=>{
    if (ffEnabled) return true;
    if (pages.length === 0) return false;
    return !isOnlyMigratedIntroVideoPage(pages, introVideo);
};
const isOnlyMigratedIntroVideoPage = (pages, introVideo)=>{
    if (pages.length !== 1) return false;
    const [only] = pages;
    if (only.type !== 'video') return false;
    if (introVideo == null || introVideo.type !== IntroVideoType.VideoLink) return false;
    return only.video.videoUrl === introVideo.videoLink.url;
};
export function isCustomPageContentEdited(current, original) {
    if (original == null) return false;
    if (current.type === 'text' && original.type === 'text') {
        return current.text.textId !== original.text.textId;
    }
    if (current.type === 'pdf' && original.type === 'pdf') {
        return current.pdf.pdfName !== original.pdf.pdfName || current.pdf.pdfFileName !== original.pdf.pdfFileName;
    }
    return false;
}
export const isCustomPageContentInvalid = (page)=>{
    switch(page.type){
        case 'text':
            return page.text.textId === '' || page.text.isEmpty === true || page.text.saveFailed === true;
        case 'pdf':
            return page.pdf.pdfName === '';
        case 'video':
            return !isUrlValid(page.video.videoUrl);
    }
};
export const toCustomPageDTO = (page)=>{
    if (page.type !== 'text') return page;
    const _page_text = page.text, { isEmpty: _isEmpty, saveFailed: _saveFailed } = _page_text, text = _object_without_properties(_page_text, [
        "isEmpty",
        "saveFailed"
    ]);
    return _object_spread_props(_object_spread({}, page), {
        text
    });
};
export const createBlankVideoPage = (id, displayOrder)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'video',
        video: {
            videoUrl: ''
        }
    });
export const createBlankTextPage = (id, displayOrder, textId)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'text',
        text: {
            textId
        }
    });
export const createBlankPdfPage = (id, displayOrder, pdfName, pdfFileName)=>({
        id,
        pageTitle: DEFAULT_PAGE_TITLE,
        displayOrder,
        displayScope: DEFAULT_DISPLAY_SCOPE,
        type: 'pdf',
        pdf: {
            pdfName,
            pdfFileName
        }
    });
